<div class="col-sm-12 px-1">
  <div class="d-flex justify-content-center">
    <button
      class="btn btn-reset col text-center m-4"
      [disabled]="!app.filterDashboard.enableReset"
      (click)="app.filterDashboard.resetFilter(true)"
    >
      <i class="fas fa-redo-alt"></i>
      {{ app.text.graphs.resetFilter }}
    </button>
  </div>
  <app-frame
    [title]="app.text.graphs.omFilters"
    [changeHeader]="true"
    [filterBox]="true"
  >
    <form class="form-inline">
      <!-- From Date -->
      <div class="form-group">
        <label for="fDate" class="p-2">{{ app.text.graphs.filterFrom }}</label>
        <div class="input-wrapper">
          <input
            class="datepicker-dashboard pr-5"
            name="fDate"
            [(ngModel)]="app.filterDashboard.createTimeFilters.startDate"
            ngbDatepicker
            #fDate="ngbDatepicker"
            (click)="fDate.toggle()"
          />
          <i class="fa fa-calendar calendar-icon" (click)="fDate.toggle()"></i>
        </div>
      </div>

      <!-- To Date -->
      <div class="form-group">
        <label for="tDate" class="p-2">{{ app.text.graphs.filterTo }}</label>
        <div class="input-wrapper">
          <input
            class="datepicker-dashboard pr-5"
            name="tDate"
            [(ngModel)]="app.filterDashboard.createTimeFilters.endDate"
            ngbDatepicker
            #tDate="ngbDatepicker"
            (click)="tDate.toggle()"
          />

          <i class="fa fa-calendar calendar-icon" (click)="tDate.toggle()"></i>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <button
          class="btn btn-default-red m-2"
          (click)="
            app.filterDashboard.getSelectedFilters();
            app.filterDashboard.enableReset = true
          "
          [disabled]="app.filterDashboard.isCreateTimeFilterDisabled()"
        >
          {{ app.text.graphs.filter }}
        </button>
      </div>
    </form>
  </app-frame>
</div>
